import { createFileRoute } from "@tanstack/react-router";

import type { WatchGameSessionViewViews } from "~/features/gameSession/types/gameSessionTypes.ts";
import GameSessionDisplayPage from "~/pages/gameSession/GameSessionDisplayPage.tsx";

type GameSessionDisplaySearch = {
    view?: WatchGameSessionViewViews;
    /** "presenter" opens the presenter view in fullscreen when the page loads. */
    open?: "presenter";
};

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/")({
    validateSearch: (search: Record<string, unknown>): GameSessionDisplaySearch => {
        return {
            view: (search.view as WatchGameSessionViewViews) || "stats",
            open: search.open === "presenter" ? "presenter" : undefined,
        };
    },
    component: GameSessionDisplayPage,
});
